import { useQuery } from "@tanstack/react-query";

import useSalesyApiClient from "@/hooks/useSalesyApiClient";

export const onboardingSuggestionQueryKey = ["company-suggestion"];

export const useGetOnboardingSuggestion = () => {
  const { apiClient } = useSalesyApiClient();

  return useQuery({
    queryKey: onboardingSuggestionQueryKey,
    queryFn: () => apiClient.onboarding.getCompanySuggestion(),
  });
};
